import { CONTACT } from "@/data/site";

export const Footer = () => {
    return (
        <footer className="bg-black border-t border-[#D4AF37]/15 py-10">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
                {/* Brand lockup */}
                <div className="flex items-center gap-3 flex-1 md:justify-start justify-center">
                    <div className="h-12 w-12 grid place-items-center shrink-0">
                        <img
                            src="/assets/young-mogul-logo.png"
                            alt="Young Mogul"
                            className="h-full w-full object-contain drop-shadow-[0_0_10px_rgba(212,175,55,0.4)]"
                        />
                    </div>
                    <div>
                        <div className="font-display text-sm uppercase tracking-wider text-white">
                            EDUtainment Pros
                        </div>
                        <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">
                            Young Mogul Program
                        </div>
                    </div>
                </div>

                {/* Copyright (center) */}
                <div className="flex-1 text-xs text-white/40 uppercase tracking-[0.2em] text-center">
                    © 2017 EDUtainment Pros · Sacramento, CA
                </div>

                {/* Contact (right) */}
                <div className="flex-1 flex flex-wrap items-center justify-center md:justify-end gap-5 text-xs uppercase tracking-[0.2em] text-white/50">
                    <a
                        href={`tel:${CONTACT.phone.replace(/[^0-9+]/g, "")}`}
                        className="hover:text-[#D4AF37] transition-colors"
                    >
                        {CONTACT.phone}
                    </a>
                    <a
                        href={`mailto:${CONTACT.email}`}
                        className="hover:text-[#D4AF37] transition-colors"
                    >
                        {CONTACT.email}
                    </a>
                </div>
            </div>
        </footer>
    );
};
